import {Button, Form, Modal, ToggleButton, ToggleButtonGroup, Alert} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Controller, useForm, useWatch} from "react-hook-form";
import SelectHealthInsurance from "../../../components/SelectHealthInsurance";
import {useHealthInsurances} from "../../../hooks/api/healthInsurances";

const Step2Verification = ({tiersPayant, loading, handleClose, onSubmit}) => {
    const { t } = useTranslation();
    const [insuranceIsCorrect, setInsuranceIsCorrect] = useState(0)
    const [updateInsurance, setUpdateInsurance] = useState(0)
    const [newHealthInsurance, setNewHealthInsurance] = useState(null)

    const [sendingType, setSendingType] = useState(null)
    const [documentIsPec, setDocumentIsPec] = useState(null)
    const [amountIsEqual, setAmountIsEqual] = useState(null)
    const [invoiceNumberEqual, setInvoiceNumberEqual] = useState(null)
    const [, setMedicalCareOnlineInvoice] = useState(null)
    const [medicalCareSigned, setMedicalCareSigned] = useState(null)
    const [dateNotExpired, setDateNotExpired] = useState(null)
    const [{healthInsurances}, {fetchAll: fetchAllHealthInsurance}] = useHealthInsurances()

    const {
        handleSubmit,
        formState: { errors: formErrors },
        control,
        setValue,
    } = useForm({})

    const watchedHealthInsuranceId = useWatch({ control, name: 'healthInsuranceId' })

    useEffect(() => {
        if (tiersPayant) {
            if (tiersPayant.insuranceIsCorrect !== null) {
                setInsuranceIsCorrect((tiersPayant.insuranceIsCorrect === true ? 'true' : 'false'))
                setValue('insuranceIsCorrect', (tiersPayant.insuranceIsCorrect === true ? 'true' : 'false'))
                if (tiersPayant.type === 'prosthesis_orthodontics') {
                    setUpdateInsurance((tiersPayant.insuranceIsCorrect === true ? 'false' : 'true'))
                }
            }

            if (tiersPayant.updateInsurance !== null) {
                setUpdateInsurance((tiersPayant.updateInsurance === true ? 'true' : 'false'))
                setValue('updateInsurance', (tiersPayant.updateInsurance === true ? 'true' : 'false'))
                if (tiersPayant.healthInsurance) {
                    setValue('healthInsuranceId', tiersPayant.healthInsurance.id)
                    setNewHealthInsurance(tiersPayant.healthInsurance.id)
                }
            }

            if (tiersPayant.invoiceNumberEqual !== null) {
                setValue('invoiceNumberEqual', (tiersPayant.invoiceNumberEqual === true ? 'true' : 'false'))
                setInvoiceNumberEqual(tiersPayant.invoiceNumberEqual)
            }
            if (tiersPayant.amountIsEqual !== null) {
                setValue('amountIsEqual', (tiersPayant.amountIsEqual === true ? 'true' : 'false'))
                setAmountIsEqual(tiersPayant.amountIsEqual)
            }
            if (tiersPayant.medicalCareOnlineInvoice !== null) {
                setValue('medicalCareOnlineInvoice', (tiersPayant.medicalCareOnlineInvoice === true ? 'true' : 'false'))
                setMedicalCareOnlineInvoice(tiersPayant.medicalCareOnlineInvoice)
            }
            if (tiersPayant.medicalCareSigned !== null) {
                setValue('medicalCareSigned', (tiersPayant.medicalCareSigned === true ? 'true' : 'false'))
                setMedicalCareSigned(tiersPayant.medicalCareSigned)
            }
            if (tiersPayant.dateNotExpired !== null) {
                setValue('dateNotExpired', (tiersPayant.dateNotExpired === true ? 'true' : 'false'))
                setDateNotExpired(tiersPayant.dateNotExpired)
            }
            if (tiersPayant.documentIsPec !== null) {
                setValue('documentIsPec', (tiersPayant.documentIsPec === true ? 'true' : 'false'))
                setDocumentIsPec(tiersPayant.documentIsPec)
            }
            if (tiersPayant.hasCpamReimbursement !== null) {
                setValue('hasCpamReimbursement', (tiersPayant.hasCpamReimbursement === true ? 'true' : 'false'))
            }

            if (tiersPayant.calculatedSendingType) {
                setValue('sendingType', tiersPayant.calculatedSendingType)
                setSendingType(tiersPayant.calculatedSendingType)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tiersPayant]);

    useEffect(() => {
        if (watchedHealthInsuranceId && healthInsurances) {
            setNewHealthInsurance(watchedHealthInsuranceId)
            Object.keys(healthInsurances).forEach((key) => {
                if (healthInsurances[key].id === watchedHealthInsuranceId) {
                    if (tiersPayant.type === 'care') {
                        setValue('sendingType', healthInsurances[key].sendingTypeForCare)
                        setSendingType(healthInsurances[key].sendingTypeForCare)
                    } else {
                        setValue('sendingType', healthInsurances[key].sendingTypeForProsthesisOrthodontics)
                        setSendingType(healthInsurances[key].sendingTypeForProsthesisOrthodontics)
                    }
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchedHealthInsuranceId]);

    const validateSubmit = ({insuranceIsCorrect, sendingType, healthInsuranceId, updateInsurance, amountIsEqual, invoiceNumberEqual, medicalCareOnlineInvoice, medicalCareSigned, dateNotExpired, hasCpamReimbursement, documentIsPec}) => {
        const insuranceIsCorrectBool = insuranceIsCorrect === null ? null : (insuranceIsCorrect === 'true');
        const updateInsuranceBool = updateInsurance === null ? null : (updateInsurance === 'true');

        if (tiersPayant.type === 'care') {
            const data = {
                insuranceIsCorrect: insuranceIsCorrectBool,
                sendingType,
                healthInsuranceId,
                updateInsurance: updateInsuranceBool
            }

            if (insuranceIsCorrect === 'true') {
                onSubmit(data)
            } else {
                if (updateInsurance === 'false') {
                    onSubmit(data)
                } else if (healthInsuranceId !== null) {
                    onSubmit(data)
                }
            }
        }

        const amountIsEqualBool = amountIsEqual === null ? null : (amountIsEqual === 'true');
        const invoiceNumberEqualBool = invoiceNumberEqual === null ? null : (invoiceNumberEqual === 'true');
        const medicalCareOnlineInvoiceBool = medicalCareOnlineInvoice === null ? null : (medicalCareOnlineInvoice === 'true');
        const medicalCareSignedBool = medicalCareSigned === null ? null : (medicalCareSigned === 'true');
        const dateNotExpiredBool = dateNotExpired === null ? null : (dateNotExpired === 'true');
        const hasCpamReimbursementBool = hasCpamReimbursement === null ? null : (hasCpamReimbursement === 'true');
        const documentIsPecBool = documentIsPec === null ? null : (documentIsPec === 'true');

        if (tiersPayant.type === 'prosthesis_orthodontics') {
            onSubmit({
                sendingType,
                amountIsEqual: amountIsEqualBool,
                invoiceNumberEqual: invoiceNumberEqualBool,
                medicalCareOnlineInvoice: medicalCareOnlineInvoiceBool,
                medicalCareSigned: medicalCareSignedBool,
                dateNotExpired: dateNotExpiredBool,
                hasCpamReimbursement: hasCpamReimbursementBool,
                insuranceIsCorrect: insuranceIsCorrectBool,
                documentIsPec: documentIsPecBool,
                healthInsuranceId,
                updateInsurance: updateInsuranceBool
            })
        }
    }

    return (
        <Form onSubmit={handleSubmit(validateSubmit)}>
            {tiersPayant.type === 'care' && (
                <>
                    <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                        <Form.Label>{t('tiers-payant.manage.form.insurance-correct.label')}</Form.Label>
                        <Controller
                            name="insuranceIsCorrect"
                            control={control}
                            rules={{ required: 'error-empty' }}
                            render={({ field }) => (
                                <ToggleButtonGroup
                                    type="radio"
                                    value={field.value}
                                    onChange={(val) => {
                                        field.onChange(val)
                                        setInsuranceIsCorrect(val)
                                        setNewHealthInsurance(null)
                                        setValue('healthInsuranceId', null)
                                        setValue('updateInsurance', null)
                                        setUpdateInsurance(null)
                                    }}
                                    name="insuranceIsCorrect"
                                    style={{marginLeft: '10px'}}
                                >
                                    <ToggleButton id="insuranceIsCorrect-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                    <ToggleButton id="insuranceIsCorrect-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />
                    </Form.Group>

                    <Alert variant="warning">
                        <div className="alert-message">
                            <div className="block">
                                La carte mutuelle du patient doit être valide et doit respecter le process de conformité.
                            </div>
                            <div className="block sm:inline">
                                Pour savoir comment lire une carte mutuelle valide, <a href="https://astucetierspayant.atlassian.net/wiki/spaces/Process/overview" target="_blank" rel="noreferrer">cliquer-ici</a>.
                            </div>

                        </div>
                    </Alert>

                    {insuranceIsCorrect === 'false' && (<Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                        <Form.Label>
                            {t('tiers-payant.manage.form.insurance-not-correct.label')}
                        </Form.Label>
                        <Controller
                            id="updateInsurance"
                            name="updateInsurance"
                            control={control}
                            render={({ field }) => (
                                <ToggleButtonGroup
                                    id="updateInsurance"
                                    type="radio"
                                    value={field.value}
                                    onChange={(val) => {
                                        field.onChange(val)
                                        setUpdateInsurance(val)
                                        if (val === 'false') {
                                            setNewHealthInsurance(null)
                                            setValue('healthInsuranceId', null)
                                        }
                                    }}
                                    name="updateInsurance"
                                    style={{marginLeft: '10px'}}
                                >
                                    <ToggleButton id="updateInsurance-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                    <ToggleButton id="updateInsurance-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />

                        {updateInsurance === 'true' && (<SelectHealthInsurance
                            name="healthInsuranceId"
                            control={control}
                            placeholder={t('tiers-payant.form.healthInsurance.place-holder')}
                            isInvalid={formErrors && formErrors.healthInsuranceId}
                            healthInsurances={healthInsurances}
                            fetchAllHealthInsurance={fetchAllHealthInsurance}
                            className={`p-0 form-control form-control-lg ${formErrors && formErrors.healthInsuranceId ? ' is-invalid' : ''}`}
                            size="lg"
                        />)}
                    </Form.Group>)}

                    {(insuranceIsCorrect === 'true' || (newHealthInsurance && updateInsurance === 'true')) && (<>
                        <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                            <Form.Label>{t('tiers-payant.manage.form.sending-type.label')}</Form.Label>
                            <Controller
                                name="sendingType"
                                control={control}
                                rules={{ required: 'error-empty' }}
                                render={({ field }) => (
                                    <>
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="teletransmission"
                                            value="teletransmission"
                                            label={t('tiers-payant.manage.form.sending-type.teletransmission')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'teletransmission'}
                                        />
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="web_portal"
                                            value="web_portal"
                                            label={t('tiers-payant.manage.form.sending-type.web_portal')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'web_portal'}
                                        />
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="letter"
                                            value="letter"
                                            label={t('tiers-payant.manage.form.sending-type.letter')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'letter'}
                                        />
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="mail"
                                            value="mail"
                                            label={t('tiers-payant.manage.form.sending-type.mail')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'mail'}
                                        />
                                    </>
                                )}
                            />
                        </Form.Group>
                    </>)}
                </>
            )}
            {tiersPayant.type === 'prosthesis_orthodontics' && (
                <>
                    <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                        <Form.Label>{t('tiers-payant.manage.form.insurance-correct.label')}</Form.Label>
                        <Controller
                            name="insuranceIsCorrect"
                            control={control}
                            rules={{ required: 'error-empty' }}
                            render={({ field }) => (
                                <ToggleButtonGroup
                                    type="radio"
                                    value={field.value}
                                    onChange={(val) => {
                                        field.onChange(val)
                                        setInsuranceIsCorrect(val)
                                        setNewHealthInsurance(null)
                                        setValue('healthInsuranceId', null)
                                        setValue('updateInsurance', null)
                                        setUpdateInsurance(val === 'false' ? 'true' : 'false')
                                        if (val === 'false') {
                                            setNewHealthInsurance(null)
                                            setValue('healthInsuranceId', null)
                                        }
                                    }}
                                    name="insuranceIsCorrect"
                                    style={{marginLeft: '10px'}}
                                >
                                    <ToggleButton id="insuranceIsCorrect-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                    <ToggleButton id="insuranceIsCorrect-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                        {updateInsurance === 'true' && (<SelectHealthInsurance
                            name="healthInsuranceId"
                            control={control}
                            placeholder={t('tiers-payant.form.healthInsurance.place-holder')}
                            isInvalid={formErrors && formErrors.healthInsuranceId}
                            healthInsurances={healthInsurances}
                            fetchAllHealthInsurance={fetchAllHealthInsurance}
                            className={`p-0 form-control form-control-lg ${formErrors && formErrors.healthInsuranceId ? ' is-invalid' : ''}`}
                            size="lg"
                        />)}
                    </Form.Group>

                    {(insuranceIsCorrect === 'true' || (insuranceIsCorrect === 'false' && newHealthInsurance)) && <>
                        <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                            <Form.Label>{t('tiers-payant.manage.form.sending-type.label')}</Form.Label>
                            <Controller
                                name="sendingType"
                                control={control}
                                rules={{ required: 'error-empty' }}
                                render={({ field }) => (
                                    <>
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="mail"
                                            value="mail"
                                            label={t('tiers-payant.manage.form.sending-type.mail')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'mail'}
                                        />
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="web_mail"
                                            value="web_mail"
                                            label={t('tiers-payant.manage.form.sending-type.web_mail')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'web_mail'}
                                        />
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="web_portal"
                                            value="web_portal"
                                            label={t('tiers-payant.manage.form.sending-type.web_portal')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'web_portal'}
                                        />
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="letter"
                                            value="letter"
                                            label={t('tiers-payant.manage.form.sending-type.letter')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'letter'}
                                        />
                                        <Form.Check
                                            name="sendingType"
                                            type="radio"
                                            id="teletransmission"
                                            value="teletransmission"
                                            label={t('tiers-payant.manage.form.sending-type.teletransmission')}
                                            onChange={(val) => { field.onChange(val); setSendingType(val.target.value); }}
                                            checked={field.value === 'teletransmission'}
                                        />
                                    </>
                                )}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="tiers-payant.document-is-pec">
                            <Form.Label>{t('tiers-payant.manage.form.document-is-pec.label')}</Form.Label>
                            <Controller
                                name="documentIsPec"
                                control={control}
                                rules={{ required: 'error-empty' }}
                                render={({ field }) => (
                                    <ToggleButtonGroup
                                        type="radio"
                                        value={field.value}
                                        name={field.name}
                                        style={{marginLeft: '10px'}}
                                        onChange={(val) => {
                                            field.onChange(val)
                                            setDocumentIsPec(val === 'true')
                                        }}
                                    >
                                        <ToggleButton id="documentIsPec-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                        <ToggleButton id="documentIsPec-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            />
                        </Form.Group>

                        {documentIsPec === true && <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                            <Form.Label>{t('tiers-payant.manage.form.date-not-expired.label')}</Form.Label>
                            <Controller
                                name="dateNotExpired"
                                control={control}
                                rules={{ required: 'error-empty' }}
                                render={({ field }) => (
                                    <ToggleButtonGroup
                                        type="radio"
                                        value={field.value}
                                        name={field.name}
                                        style={{marginLeft: '10px'}}
                                        onChange={(val) => {
                                            field.onChange(val)
                                            setDateNotExpired(val === 'true')
                                        }}
                                    >
                                        <ToggleButton id="dateNotExpired-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                        <ToggleButton id="dateNotExpired-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            />
                        </Form.Group>}
                        {documentIsPec === true && dateNotExpired === true && <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                            <Form.Label>{t('tiers-payant.manage.form.amount-is-equal.label')}</Form.Label>
                            <Controller
                                name="amountIsEqual"
                                control={control}
                                rules={{ required: 'error-empty' }}
                                render={({ field }) => (
                                    <ToggleButtonGroup
                                        type="radio"
                                        value={field.value}
                                        name={field.name}
                                        style={{marginLeft: '10px'}}
                                        onChange={(val) => {
                                            field.onChange(val)
                                            setAmountIsEqual(val === 'true')
                                        }}
                                    >
                                        <ToggleButton id="amountIsEqual-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                        <ToggleButton id="amountIsEqual-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            />
                        </Form.Group>}
                        {documentIsPec === true && dateNotExpired === true && amountIsEqual === true && <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                            <Form.Label>{t('tiers-payant.manage.form.invoice-number-equal.label')}</Form.Label>
                            <Controller
                                name="invoiceNumberEqual"
                                control={control}
                                rules={{ required: 'error-empty' }}
                                render={({ field }) => (
                                    <ToggleButtonGroup
                                        type="radio"
                                        value={field.value}
                                        name={field.name}
                                        style={{marginLeft: '10px'}}
                                        onChange={(val) => {
                                            field.onChange(val)
                                            setInvoiceNumberEqual(val === 'true')
                                        }}
                                    >
                                        <ToggleButton id="invoiceNumberEqual-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                        <ToggleButton id="invoiceNumberEqual-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            />
                        </Form.Group>}
                        {sendingType === 'mail' && documentIsPec === true && dateNotExpired === true && amountIsEqual === true && invoiceNumberEqual === true &&
                            <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                                <Form.Label>{t('tiers-payant.manage.form.medical-care-signed.label')}</Form.Label>
                                <Controller
                                    name="medicalCareSigned"
                                    control={control}
                                    rules={{ required: 'error-empty' }}
                                    render={({ field }) => (
                                        <ToggleButtonGroup
                                            type="radio"
                                            value={field.value}
                                            name={field.name}
                                            style={{marginLeft: '10px'}}
                                            onChange={(val) => {
                                                field.onChange(val)
                                                setMedicalCareSigned(val === 'true')
                                            }}
                                        >
                                            <ToggleButton id="medicalCareSigned-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                            <ToggleButton id="medicalCareSigned-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                        </ToggleButtonGroup>
                                    )}
                                />
                            </Form.Group>
                        }
                        {sendingType === 'web_portal' && documentIsPec === true && dateNotExpired === true && amountIsEqual === true && invoiceNumberEqual === true &&
                            <Form.Group className="mb-3" controlId="tiers-payant.insurance-correct">
                                <Form.Label>{t('tiers-payant.manage.form.medical-care-online-invoice.label')}</Form.Label>
                                <Controller
                                    name="medicalCareOnlineInvoice"
                                    control={control}
                                    rules={{ required: 'error-empty' }}
                                    render={({ field }) => (
                                        <ToggleButtonGroup
                                            type="radio"
                                            value={field.value}
                                            name={field.name}
                                            style={{marginLeft: '10px'}}
                                            onChange={(val) => {
                                                field.onChange(val)
                                                setMedicalCareOnlineInvoice(val === 'true')
                                            }}
                                        >
                                            <ToggleButton id="medicalCareOnlineInvoice-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                            <ToggleButton id="medicalCareOnlineInvoice-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                        </ToggleButtonGroup>
                                    )}
                                />
                            </Form.Group>
                        }
                        {((sendingType === 'mail' && documentIsPec === true && dateNotExpired === true && amountIsEqual === true && invoiceNumberEqual === true && medicalCareSigned === true)
                                || (sendingType === 'web_mail' && documentIsPec === true && dateNotExpired === true && amountIsEqual === true && invoiceNumberEqual === true)) &&
                            <Form.Group className="mb-3" controlId="tiers-payant.has-cpam-reimbursement">
                                <Form.Label>{t('tiers-payant.manage.form.has-cpam-reimbursement.label')}</Form.Label>
                                <Controller
                                    name="hasCpamReimbursement"
                                    control={control}
                                    rules={{ required: 'error-empty' }}
                                    render={({ field }) => (
                                        <ToggleButtonGroup
                                            type="radio"
                                            value={field.value}
                                            name={field.name}
                                            style={{marginLeft: '10px'}}
                                            onChange={(val) => {
                                                field.onChange(val)
                                            }}
                                        >
                                            <ToggleButton id="hasCpamReimbursement-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                            <ToggleButton id="hasCpamReimbursement-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                        </ToggleButtonGroup>
                                    )}
                                />
                            </Form.Group>
                        }
                    </>}
                </>
            )}

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    {t('tiers-payant.manage.button.cancel')}
                </Button>
                <Button variant="primary" type="submit">
                    {t('tiers-payant.manage.button.next')}
                </Button>
            </Modal.Footer>
        </Form>
    )
}

export default Step2Verification
